// src/components/apiCalls/pagination/pageBatch.ts
// Maps a Firestore QuerySnapshot fetched with .limit(pageSize + 1) into a PageBatch.
export const snapshotToPageBatch = (snap: any, pageSize: number, afterDoc: any) => {
    const docs = snap.docs.filter((d: any) => { return d.exists; });
    const hasMore = docs.length > pageSize;
    const pageDocs = docs.slice(0, pageSize);
    const items = pageDocs.map((d: any) => { return { ...d.data() }; });
    const lastDoc = pageDocs.length ? pageDocs[pageDocs.length - 1] : afterDoc;
    return { items, lastDoc, hasMore };
};
